// Libs
import React from "react";

import { Label, HiddenCheckbox, Title } from "./QuickFilterStyle";

const QuickFilter = ({ checked, children, className, ...props }) => {
  return (
    <Label checked={checked} className={className}>
      <HiddenCheckbox checked={checked} {...props} />
      <Title>{children}</Title>
    </Label>
  );
};

export default QuickFilter;



// WEBPACK FOOTER //
// ./src/newDropshipperApp/pages/search/quickFilters/QuickFilter.js